export const tableSettings = {
  searchFields: [{ label: 'Lane Name', param: 'lane', inputWidth: '400px' }],
  pageSelectTitle: 'Lanes',
  initialSortColumn: 'sequence',
  initialSortDirection: 'asc',
  standardStoreParams: [
    'searchText',
    'pageNumber',
    'pageSize',
    'sortColumn',
    'sortDirection',
  ],
  getMethods: (lanes) => {
    return {
      name: 'lanes',
      fn: lanes.fn,
      args: ['auctionID', ...tableSettings.standardStoreParams],
      dataToMerge: {
        auctionID: lanes.auctionId,
        auctionName: lanes.auctionName,
      },
    };
  },
};

const headerSchema = [
  {
    index: 11,
    value: '',
    text: 'Transcript',
    sort: false,
  },
  { index: 1, value: 'lane', text: 'Lane Name', sort: true },
  {
    index: 2,
    value: 'sequence',
    text: 'Sequence',
    sort: true,
    initialSort: true,
  },
  {
    index: 12,
    value: 'streamer',
    text: 'Streamer',
    sort: false,
  },
  { index: 3, value: 'numberOfProducts', text: 'Products', sort: true },
  { index: 4, value: 'numberOfImages', text: 'Images', sort: true },
  { index: 5, value: 'numberOfProxyBids', text: 'Proxy Bids', sort: true },
];

const bodySchema = [
  {
    index: 11,
    value: ['auctionID'],
    content: {
      type: 'buttons',
      value: [
        {
          text: 'View Transcript',
          url: ['auction', '[auctionID]', 'auctionTranscriptReport'],
          key: '[laneID]',
          state: {
            auctionID: '[auctionID]',
            auctionName: 'auctionName',
            laneName: '[lane]',
            laneID: '[laneID]',
          },
        },
      ],
    },
    style: {
      width: '150px',
    },
  },
  {
    index: 1,
    value: 'lane',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 2,
    value: 'sequence',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 12,
    value: 'streamer',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 3,
    value: 'numberOfProducts',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfProducts]',
          icon: 'motorcycle',
          basic: true,
          url: ['auction', '[auctionID]', 'lane', '[laneID]', 'products'],
          state: { auctionName: 'auctionName', laneName: '[lane]' },
          key: '[laneID]',
        },
      ],
    },
  },
  {
    index: 4,
    value: 'numberOfImages',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfImages]',
          icon: 'images outline',
          color: 'orange',
          basic: true,
          url: ['auction', '[auctionID]', 'lane', '[laneID]', 'productImages'],
          state: { auctionName: 'auctionName', laneName: '[lane]' },
          key: '[laneID]',
        },
      ],
    },
  },
  {
    index: 5,
    value: 'numberOfProxyBids',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfProxyBids]',
          icon: 'gavel',
          color: 'green',
          basic: true,
          url: ['auction', '[auctionID]', 'proxyBids'],
          state: { auctionName: 'auctionName', laneName: '[lane]' },
          key: '[laneID]',
        },
      ],
    },
  },
];

export const schema = {
  tableSettings,
  headerSchema,
  bodySchema,
  debugging: false,
};
